import spriteUrl from "../../assets/images/sprite.svg";
import spriteUrl2 from "../../assets/images/sprite-best.svg";
import customerSpriteUrl2 from "../../assets/images/sprite_blue-design-theme.svg";
import customerSpriteTheme5 from "../../assets/images/sprite-theme5.svg";
import loaderGifUrl from "../../assets/images/loader.gif";

export default {
  sprite: ({ webDesignContextPath }: { webDesignContextPath: string }): string =>
    `url("${webDesignContextPath + spriteUrl}")`,
  sprite2: ({ webDesignContextPath }: { webDesignContextPath: string }): string =>
    `url("${webDesignContextPath + spriteUrl2}")`,
  customerSprite: ({ webDesignContextPath }: { webDesignContextPath: string }): string =>
    `url("${webDesignContextPath + spriteUrl}")`,
  customerSprite2: ({ webDesignContextPath }: { webDesignContextPath: string }): string =>
    `url("${webDesignContextPath + customerSpriteUrl2}")`,
  loaderGif: ({ webDesignContextPath }: { webDesignContextPath: string }): string =>
    `url("${webDesignContextPath + loaderGifUrl}")`,
  customerSpriteTheme5: ({ webDesignContextPath }: { webDesignContextPath: string }): string =>
    `url("${webDesignContextPath + customerSpriteTheme5}")`,
  colors: {
    primaryColor: "#00d2b4",
    primaryColorLighter: "#62ffe6",
    primaryColorDarker: "#00a084",
    primaryFontColor: "#000",
    secondaryColor: "#3c0078",
    secondaryColorLighter: "#6e34a8",
    secondaryColorDarker: "#0d004b",
    secondaryFontColor: "#fff",
    gray: "#e0e0e0",
    darkGray: "#9e9e9e",
    lightGray: "#fafafa",
    contrastDark: "#000",
    contrastLight: "#fff",
    errorColor: "#b00020",
    confirmColor: "#00c853",
    transparent: "transparent",
    warning: "#e02020",

    darkerGray: "#727a86",
    midGray: "#eaeaea",
    blue: "#009bd4",
    black: "#000",
    white: "#fff",
    red: "#d0392a",
    violet: "#9e78c5",
    redLighter: "#df4318",
  },
  breakpoints: {
    $xs: "max-width: 767px",
    $minXs: "min-width: 768px",
    $sm: "max-width: 920px",
    $maxSm: "max-width: 1024px",
    $minSm: "min-width: 1025px",
    $md: "min-width: 1120px",
    $lg: "min-width: 1400px",
  },
  layout: {
    maxContainerWidth: "1420px",
    minContainerWidth: "320px",
  },
  fixedpoints: {
    $mobile: "155px",
    $mobilelead: "100%",
    $mobileform: "100%",
    $tablet: "216px",
    $tabletlead: "100%",
    $tabletform: "90%",
    $desktop: "216px",
    $desktoplead: "100%",
    $desktopform: "730px",
  },
};
